export default __webpack_public_path__ + "static/media/Bandit's Hood of Woven Clouds.aac9837c.jpg";